export default "__VITE_ASSET__e1337446__"